import { bbitApiWithoutNotification } from '@app/api/make-request'
import { IFile } from '@app/interfaces/files'
import { Image, Tag } from 'antd'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import userFallback from '@app/assets/images/user-fallback.png'

interface props {
  fileId?: string
  width?: number
  height?: number
}

const OrganizationPupilImageItem: React.FC<props> = ({
  fileId = '',
  width = 40,
  height = 40,
}) => {
  const { t } = useTranslation()
  const [image, setImage] = useState<IFile | null>()
  const [error, setError] = useState(false)

  useEffect(() => {
    if (fileId) {
      const abortInstance = new AbortController()
      bbitApiWithoutNotification
        .get(`${process.env.REACT_APP_HOST}files/api/v1/files/${fileId}`, {
          signal: abortInstance.signal,
        })
        .then((res) => setImage(res.data))
        .catch((error) => {
          setError(true)
        })
      return () => abortInstance.abort()
    } else setImage(null)
  }, [fileId])

  if (!fileId) {
    return <Tag color={'volcano'}>{t('general.no')}</Tag>
  }

  if (error) {
    return (
      <span style={{ color: 'red', fontSize: '12px' }}>
        {t('errors.photo_download_failed_short')}
      </span>
    )
  }

  return (
    <Image
      width={width}
      height={height}
      src={
        image
          ? `${process.env.REACT_APP_HOST}files${image.baseURL}/750x750-${image.filePath}`
          : ''
      }
      fallback={userFallback}
    />
  )
}

export default OrganizationPupilImageItem
